"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["UNKNOWN"] = 0] = "UNKNOWN";
    // basic
    ErrorCode[ErrorCode["EXTERNAL"] = 1000] = "EXTERNAL";
    ErrorCode[ErrorCode["INTERNAL"] = 1001] = "INTERNAL";
    // registration
    ErrorCode[ErrorCode["REGISTRATION"] = 10000] = "REGISTRATION";
    ErrorCode[ErrorCode["USER_ALREADY_BOUND_MOBILE"] = 10001] = "USER_ALREADY_BOUND_MOBILE";
    ErrorCode[ErrorCode["MOBILE_BOUND_BY_OTHER_USER"] = 10002] = "MOBILE_BOUND_BY_OTHER_USER";
    ErrorCode[ErrorCode["ACCOUNT_MERGE_HAS_CONFLICTS"] = 10003] = "ACCOUNT_MERGE_HAS_CONFLICTS";
    ErrorCode[ErrorCode["USER_ENROLLMENT_CONFLICT"] = 10004] = "USER_ENROLLMENT_CONFLICT";
    // auth
    ErrorCode[ErrorCode["AUTHORIZATION"] = 20000] = "AUTHORIZATION";
    ErrorCode[ErrorCode["TOKEN_EXPIRED_OR_INVALID"] = 20001] = "TOKEN_EXPIRED_OR_INVALID";
    ErrorCode[ErrorCode["INVALID_SMS_CODE"] = 20002] = "INVALID_SMS_CODE";
    // CRUD
    ErrorCode[ErrorCode["CRUD"] = 30000] = "CRUD";
    ErrorCode[ErrorCode["ALREADY_EXISTS"] = 30001] = "ALREADY_EXISTS";
    ErrorCode[ErrorCode["INVALID_VALUE"] = 30002] = "INVALID_VALUE";
    // inventory
    ErrorCode[ErrorCode["INVENTORY"] = 40000] = "INVENTORY";
    ErrorCode[ErrorCode["SKU_OUT_OF_STOCK"] = 40001] = "SKU_OUT_OF_STOCK";
    ErrorCode[ErrorCode["SKU_NOT_AVAILABLE"] = 40002] = "SKU_NOT_AVAILABLE";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
var EventType;
(function (EventType) {
    EventType[EventType["REGISTER"] = 0] = "REGISTER";
    EventType[EventType["LANDING"] = 1] = "LANDING";
    EventType[EventType["BUY"] = 2] = "BUY";
    EventType[EventType["FOLLOW"] = 3] = "FOLLOW";
    EventType[EventType["SUPPORT"] = 4] = "SUPPORT";
})(EventType = exports.EventType || (exports.EventType = {}));
//# sourceMappingURL=wechat.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/wechat.js
// module id = 1011
// module chunks = 0